import { TargetTypeEnum } from '@ais-ui/websockets';
import type { ShipInfo, TargetInfoType } from '@ais-ui/websockets';
import type { VesselResult } from '@ais-ui/api-spec/shipdb';
import type { Ship } from '@ais-ui/utils';

const toStringOrNull = (value: unknown): string | null =>
  value != null && value !== '' ? String(value) : null;

/**
 * Builds the addressed-message receiver for the selected map target.
 *
 * `Ship` targets carry a {@link ShipInfo}, while `ExtendedVessel` targets
 * carry a {@link VesselResult} (with the identifiers under `basic`). Returns
 * `null` when no MMSI is available, so the Send Message dialog is not
 * preselected with an unusable receiver.
 */
export const buildMessageReceiver = (
  targetInfo: TargetInfoType,
  targetType: TargetTypeEnum,
): Ship | null => {
  let receiver: Ship;

  if (targetType === TargetTypeEnum.ExtendedVessel) {
    const basic = (targetInfo as VesselResult).basic;
    receiver = {
      name: toStringOrNull(basic?.vesselName),
      mmsi: toStringOrNull(basic?.vesselMmsiNumber),
      callSign: toStringOrNull(basic?.callSign),
      imo: toStringOrNull(basic?.vesselImoNumber),
      type: toStringOrNull(basic?.vesselType),
    };
  } else {
    const ship = targetInfo as ShipInfo;
    receiver = {
      name: toStringOrNull(ship.name),
      mmsi: toStringOrNull(ship.mmsi),
      callSign: toStringOrNull(ship.callSign),
      imo: toStringOrNull(ship.imo),
      type: toStringOrNull(ship.shipType),
    };
  }

  return receiver.mmsi ? receiver : null;
};
